import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "./ui/button";

export const FadeUp = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ overline, title, description, align = "left" }) => (
  <FadeUp className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""} mb-14 sm:mb-20`}>
    {overline && (
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-primary mb-4 font-mono-tech">
        {overline}
      </p>
    )}
    <h2 className="text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-foreground">
      {title}
    </h2>
    {description && (
      <p className="mt-5 text-base md:text-lg text-muted-foreground leading-relaxed">{description}</p>
    )}
  </FadeUp>
);

export const CTASection = ({
  title = "Ready to build with Vectron?",
  description = "Upload your CAD files, get an instant quote, and put our global manufacturing network to work.",
}) => (
  <section className="py-24 sm:py-32 bg-slate-950 dark:bg-card border-t border-white/10">
    <div className="max-w-7xl mx-auto px-4 sm:px-8">
      <FadeUp>
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-accent mb-4 font-mono-tech">
          Get Started
        </p>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-white max-w-2xl">
          {title}
        </h2>
        <p className="mt-5 text-base md:text-lg text-slate-400 max-w-xl leading-relaxed">{description}</p>
        <div className="mt-10 flex flex-wrap gap-4">
          <Button asChild size="lg" className="rounded-full px-8 h-12 text-base" data-testid="cta-contact-btn">
            <Link to="/contact">
              Request a Quote <ArrowRight className="ml-2 h-4 w-4" strokeWidth={1.5} />
            </Link>
          </Button>
          <Button
            asChild
            size="lg"
            variant="outline"
            className="rounded-full px-8 h-12 text-base border-white/20 bg-transparent text-white hover:bg-white hover:text-slate-950"
            data-testid="cta-partners-btn"
          >
            <Link to="/partners">Become a Partner</Link>
          </Button>
        </div>
      </FadeUp>
    </div>
  </section>
);
